/* @flow */
import QueryString from 'qs';

const SHARE_LINK = '/v1/share';

export const NEW_MESSAGE_PATHS = [
  '/messages/new',
  '/classes/[^/]*/messages/new',
  '/chat/new',
  '/inbox/new',
  SHARE_LINK,
];

function extractQueryString(url: string): string {
  const match = url.match(/[^?]*\?(.*)/);
  return match ? match[1] : '';
}

/* Some deeplinks conflict with one-off apps, so we fix certain urls
 *   before sending them to the router. If they don't conflict, we just
 *   pass them through.
 */
export default (url: string): string => {
  const matchedNewMessagePath = NEW_MESSAGE_PATHS.find(p => url.match(p));
  if (matchedNewMessagePath) {
    // Rename attachment
    const { attachment, ...queryDict } = QueryString.parse(extractQueryString(url));
    queryDict.attachmentId = attachment;

    const filteredParams = {};
    if (matchedNewMessagePath === SHARE_LINK) {
      // url is required
      if (!queryDict.url || !(queryDict.referrer || queryDict.referer)) {
        const reason = !queryDict.url
          ? "missing required 'url' parameter"
          : "missing required 'referrer' parameter";
        return (
          '/f/broken_share?reason=' +
          encodeURIComponent(reason) +
          '&path=' +
          encodeURIComponent(url)
        );
      }

      Object.assign(filteredParams, {
        link: queryDict.url,
        body: queryDict.text,
        isShareLink: true,
        referrer: queryDict.referrer || queryDict.referer,
      });
    } else {
      Object.assign(filteredParams, queryDict);
    }

    return (
      '/classes?' + QueryString.stringify({ queryParams: filteredParams, action: 'new-message' })
    );
  } else {
    return url;
  }
};
